<template>
  <div class="colums small-11 medium-10 small-centered">
    <button
      class="secondary button"
      :disabled="!$store.state.customCheckerboard.enableControls"
      @click="createNewCheckerboard()"
    >
      {{ translations.createNewCheckerboard }}
    </button>
  </div>

</template>

<script>
import PlacementHelper from '../../PlacementHelper';
export default {
  name: 'createNewCheckerboard',
  extends: PlacementHelper,
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  data() {
    return {
      model : null,
    }
  },
  methods: {
    /**
     * @function createNewCheckerboard
     * Event that go to the next component for create checkerboard
     */
    async createNewCheckerboard() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$checkerboardDataLayer.logAnalyticsEvent({
          eventLabel: this.$checkerboardDataLayer.labels.createNewCheckerboard
        });
      } else {
        dataLayer.push({
          'event': 'trackEvent',
          'eventCategory': 'customs',
          'eventAction': 'checkerboard - second component',
          'eventLabel': 'choose new colors'
        });
      }

      this.addNextComponentViews();
      const { activeComponent: activeUGCComponent } = this.$store.state.legacyNavigation;
      const { canvasConfig, components} = this.$store.state.customCheckerboard;
      this.model = this.$store.state.utils.pdmModel;
      if ( (components[activeUGCComponent] && components[activeUGCComponent].ugc  && !components[activeUGCComponent].ugc.original_image )
        || JSON.stringify(canvasConfig) !== JSON.stringify(components[activeUGCComponent].canvasConfig) ) {
        this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
        const croppedImageDataUrl = await this.loadAndCropGeneratedImage(this.model, activeUGCComponent, canvasConfig['warp']);
        const ugcTemp = await this.generatePlacementAndUgcSwatch(croppedImageDataUrl, activeUGCComponent, this.getModelSize());
        // save the config for the component
        this.$store.commit('customCheckerboard/SET_COMPONENT_CONFIG', {
          component: activeUGCComponent,
          canvasConfig: canvasConfig,
          ugc: ugcTemp
        });
      }

      const nextComponent = this.$store.getters['customCheckerboard/getNextUGCComponent'];
      this.$store.commit('customCheckerboard/SET_ACTIVE_UGC_COMPONENT',nextComponent);
      this.$store.commit('customCheckerboard/RESET_CANVAS');
      this.$store.commit('customCheckerboard/SET_SAME_UPLOAD_IMAGE', false);
      this.$store.commit('customCheckerboard/SET_SECOND_VIEW', true);
      this.$eventBus.$emit('customcheckerboard-go-to-next-step');

    },
    addNextComponentViews() {
      let { views, activeViewIndex } = this.$store.state.customCheckerboard.navigation;
      if ( views.filter(val => val === 'checkerboardColorSelector' ).length == 1 ) {
        views.splice(activeViewIndex + 1, 0, ...views.slice(0, activeViewIndex));
        this.$store.commit("customCheckerboard/SET_VIEWS", views);
      }
    },
    getModelSize() {
      return this.$recipe.getUGCSizeFromRecipe() || this.$store.state.utils.pdm.ugcDefaultSize;
    },
  }
}
</script>
